import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from "@angular/router"

import { ChangePasswordService } from '../../service/change-password.service';
import { Token } from '../../manager/token';
import { customValidation } from '../../manager/customValidators';
import { NotificationService } from 'src/app/service/notification.service';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { LoginService } from 'src/app/service/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { HeaderComponent } from 'src/app/common-components/header/header.component';
import { CommonModule } from '@angular/common';

 import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { BASE_AG_GRID_OPTIONS } from 'src/app/service/common-config';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [ChangePasswordService],
  standalone: true,
    imports: [HeaderComponent, FormsModule, CommonModule, ReactiveFormsModule,AgGridModule]
})
export class ChangePasswordComponent implements    OnInit {
gridOptions: GridOptions = {
  pagination: true,
  paginationPageSize: 15,
  rowSelection : 'single',
    suppressColumnVirtualisation: true,
  suppressDragLeaveHidesColumns: true,
...BASE_AG_GRID_OPTIONS,
};

  title: string = "Reset Password";
  ChangeForm: UntypedFormGroup;
  DisplayError: Boolean;
  DisableSubmit: Boolean = false;
  Token: Token;
  UserId: number;
  ResponseHelper;
  captchaArray = [];
  gradientColor = null;

  showCaptcha: any;
  uniqueKey: any;
  isCaptcha: boolean= false;

  minLength: number;
  maxLength: number;
  constructor(private ChangePasswordService: ChangePasswordService, private notificationservice: NotificationService, private router: Router,
    public loginservice: LoginService,
    private sanitizer: DomSanitizer) {
    this.Token = new Token(this.router);
    var data = this.Token.GetUserData();
    this.UserId = data.UserId;
  }


  ngOnInit() {
    this.createForm();
    this.ResponseHelper = new ResponseHelper(this.notificationservice);
  }

  createForm() {
    this.minLength = environment.passwordMinLength;
    this.maxLength = environment.passwordMaxLength;

    this.ChangeForm = new UntypedFormGroup({
      User_Id: new UntypedFormControl(this.UserId, [Validators.required]),
      Old_Password: new UntypedFormControl('', [Validators.required,
        //, Validators.minLength(8), Validators.maxLength(20)
      ]),
      New_Password: new UntypedFormControl('', [Validators.required
        , Validators.minLength(this.minLength), Validators.maxLength(20),
      //Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?#&])[A-Za-z\d$@$!%*?#&].{7,}')
      Validators.pattern(`^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-/(/)/_/+/]).{${this.minLength},}$`)
      ]),
      confirmnewpass: new UntypedFormControl('', [Validators.required,
        // ,Validators.minLength(8), Validators.maxLength(20)
      ]),
      captchaData: new UntypedFormControl('', [Validators.required]),
      UniqueKey: new UntypedFormControl('', null)
    }, { validators: [customValidation.MatchPassword, customValidation.NewPasswordMatchWithOld] });
    this.callCaptcha();

  }

  ChangePassword() {
    this.DisableSubmit = true;
    this.ChangeForm.patchValue({ UniqueKey : this.uniqueKey });

    if (this.ChangeForm.valid) {
      this.DisplayError = false;
      this.ChangePasswordService.ChangePassword(this.ChangeForm.value)
        .subscribe(
          (data) => {
            this.ResponseHelper.GetSuccessResponse(data)
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 2000);
          }, err => {
            this.ResponseHelper.GetFaliureResponse(err)
            this.DisableSubmit = false;
            if(err.error != null){
            if(err.error.Data == null && err.error.Message[0].Message != 'Invalid captcha.') {
              this.callCaptcha();
            }
          }
          })
    }
    else {
      this.DisplayError = true;
      this.DisableSubmit = false;
    }
  }

  // Call API for Captcha
  callCaptcha(){
    this.isCaptcha = true;

    this.loginservice.loginCaptcha().subscribe((res:any)=> {
    this.isCaptcha = false;
    // this.ResponseHelper.GetSuccessResponse(res)
    let captcha = res.Data.responseCaptcha;
    this.uniqueKey = res.Data.UniqueKey;
    this.convertToImage(captcha);
    // this.captchaArray.push(this.showCaptcha)
    }, error => {
      this.ResponseHelper.GetFaliureResponse(error)
    })
    this.ChangeForm.patchValue({ captchaData: '' });
  }

  convertToImage(captcha) {
    this.showCaptcha = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${captcha}`);
    console.log(this.showCaptcha, 'this.showCaptcha');
  }

}
